import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatCheckbox, MatDialog } from '@angular/material';
import { LocalizationService } from 'src/app/services/localization.service';
import { DniValidationDigitComponent } from '../dni-validation-digit/dni-validation-digit.component';
import { GeographicalLocation } from 'src/app/models/localization/geographical-location.model';
import { ReniecValidationRequest } from 'src/app/models/virtual-store/reniec-validation-request.model';
import Swal from 'sweetalert2';
import { Title } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/common.service';
import { MasterTableService } from 'src/app/services/master-table.service';
import { AccountService } from 'src/app/services/account.service';
import { Account } from 'src/app/models/account.model';
import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { BackOfficeService } from 'src/app/services/back-office.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppUser } from 'src/app/models/app-user.model';
import * as moment from 'moment';
import { LogPrivacyDataService } from 'src/app/services/log-privacy-data.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommercialPurposeClauseComponent } from '../../commercial-purpose-clause/commercial-purpose-clause.component';
import { HtmlPolicy } from 'src/app/models/master/html-policy.model';
import { MasterService } from 'src/app/services/master.service';
import { SharedServiceOrderObservable } from '../shared-services/shared-service-order';
import { TiendaVirtualClauseAccepted } from 'src/app/data-transfer/tienda-virtual-accepted';

@Component({
  selector: 'personal-data-validation',
  templateUrl: './personal-data-validation.component.html',
  styleUrls: ['./personal-data-validation.component.scss']
})
export class PersonalDataValidationComponent implements OnInit {
  @Input() fullName: string;
  @Input() dni: string;
  @Output() stepCompleted = new EventEmitter();
  departmentList: GeographicalLocation[] = []
  formGroup: FormGroup;
  conditionAccepted: boolean = false;
  /**Subscripción a observable de dni validado  */
  dniValidatedSubscription: Subscription;
  attemptsMax: number;
  attempts: number = 0;
  account: Account;
  accountBasicData: AccountBasicData;
  backOfficeService: BackOfficeService;
  private appUser: AppUser;
  unsubscribe$ = new Subject();
  isHideCommerce = 0;
  commercialPurposesPolicy = new HtmlPolicy();

  @ViewChild('chkAcceptCommerce_personaldata', { read: MatCheckbox, static: false })
  public chkAcceptCommerce: MatCheckbox;

  constructor(
    private tiendaVirtualClauseAccepted: TiendaVirtualClauseAccepted,
    private virtualStoreService: VirtualStoreService,
    private masterTableService: MasterTableService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private matDialog: MatDialog,
    private commonService: CommonService,
    private accountService: AccountService,
    private authService: AuthService,
    private localizationService: LocalizationService,
    private logPrivacyDataService: LogPrivacyDataService,
    private masterService: MasterService,
    private sharedServiceOrderObservable: SharedServiceOrderObservable
  ) {
    this.dniValidatedSubscription = this.virtualStoreService.dniValidatedAnnounced.subscribe(response => {

    })
  }

  async ngOnInit() {
    //this.chkAcceptCommerce.checked=null;

    await this.createForm();
    await this.getUserLogin();
    await this.getParatameter();
    await this.getAcountSelect();
    await this.listDepartments();
    //await this.getBasicData();

    await this.loadCommercialPurposesPolicy();

  }

  async getUserLogin() {
    this.appUser = this.authService.getUser();
  }

  async getAcountSelect() {
    await this.commonService.accountSelectedAnnounced.subscribe(async account => {
      this.account = account;
      //console.log(account);
      await this.getBasicData();
      await this.isMarket();

    });
  }

  async getBasicData() {
    await this.accountService.getBasicData(this.account.clientCode).toPromise().then(response => {
      this.accountBasicData = response.data;
    });


    //await this.backOfficeService.GetUser()
  }

  async createForm() {
    this.formGroup = this.formBuilder.group({
      dniValidationDigit: [null, [Validators.required]],
      birthDate: [null, [Validators.required]],
      birthPlace: [null, [Validators.required]],
      fatherName: [''],
      motherName: ['']
    }, { validators: this.fatherOrMotherNameIsNeeded })
  }

  async isMarket() {
    const request = await this.logPrivacyDataService.GetLogPrivacyData({
      clientCode: this.account.clientCode,
      typePolicyCode: "03"
    })
    request.pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
      const arrayListAccepts = response.data;
      this.isHideCommerce = arrayListAccepts.length;

    })
  }
  fatherOrMotherNameIsNeeded(abstractControl: AbstractControl) {

    if (abstractControl) {
      if (
        (abstractControl.get('fatherName').value != null
          && abstractControl.get('fatherName').value.toString().trim() != '')
        ||
        (abstractControl.get('motherName').value != null
          && abstractControl.get('motherName').value.toString().trim() != '')) {
        return null;
      } else return { fatherOrMotherNameIsNeeded: true };
    } else return null;
  }
  openDialog() {
    this.dialog.open(DniValidationDigitComponent);
  }



  async listDepartments() {
    await this.localizationService.listDepartments().toPromise().then(response => {
      this.departmentList = response.data;
    })
  }

  async getParatameter() {
    this.masterTableService.GetMasterByKey('NRO_INTENTOS_FALLIDOS_COMPRA').subscribe(response => {
      this.attemptsMax = Number(response.data.description);
    })
  }



  async validate() {
    if (this.formGroup.valid && this.conditionAccepted) {
      this.attempts++;
      let data = new ReniecValidationRequest();
      data.dni = this.dni;
      localStorage.setItem("dni", data.dni);
      data.validationDigit = this.formGroup.get('dniValidationDigit').value;
      data.birthDate = this.formGroup.get('birthDate').value;
      data.birthPlace = this.departmentList.find(x => x.code == this.formGroup.get('birthPlace').value).description;
      data.motherName = this.formGroup.get('motherName').value;
      data.fatherName = this.formGroup.get('fatherName').value;
      data.clientCode = this.account.clientCode;
      data.attemptsMax = this.attemptsMax;
      data.usuario = this.appUser;
      if (this.attemptsMax === this.attempts) {
        //Enviar correo
        data.isAttemptsMax = true;
        this.attempts = 0;
      }


      const isUndefinedAccept = this.chkAcceptCommerce === undefined;
      const IS_ACCEPT_CHECK = isUndefinedAccept ? false : this.chkAcceptCommerce.checked

      const IS_ACCEPT_RESULT = this.isHideCommerce > 0 ? null : IS_ACCEPT_CHECK;
      const clientCodeSelected = data.clientCode;
      let requestLock = {
        idUser: this.appUser.id,
        clientCode: data.clientCode,
        interlocutorId: this.account.interlocutorId,
        acceptCommerce: IS_ACCEPT_RESULT
      }

      this.accountService.accountLock(requestLock).toPromise().then(response => {
        if (response.data) {
          const fecha: string = moment(response.data.endDate).format("DD/MM/YYYY");
          Swal.fire({
            title: 'Información',
            text: `Estimado cliente, ha superado el número de intentos al identificarte. Podrás continuar el proceso de compra a partir del día de mañana desde las 00.00 hrs.`,
            icon: 'info',
            backdrop: '#0c0f0f'
          }).finally(() => {

          });
          return;
        }
        else {
          this.virtualStoreService.isPersonalDataValid(data).subscribe(response => {


            if (response.valid) {
               
              this.sharedServiceOrderObservable.updateData({ conditionAccepted: this.conditionAccepted });

              if (IS_ACCEPT_RESULT != null) {


                this.logPrivacyDataService.sendInsertPrivacyData(
                  {
                    accept: IS_ACCEPT_RESULT,
                    clientCode: clientCodeSelected,
                    interlocutorId: this.account.interlocutorId,
                    userId: "",
                    channel: "OFI",
                    policyType: "03",
                    form: "02",
                  }
                );
              }
              this.stepCompleted.emit();
            }
          })
        }
      });


    }
    else if (!this.formGroup.valid) {

      this.formGroup.markAllAsTouched();
      let errorHtml = await this.commonService.buildErrorHtml(this.formGroup);
      Swal.fire({
        icon: 'warning',
        html: errorHtml,
        confirmButtonText: 'Aceptar'
      })
    }
    else if (this.conditionAccepted == false) {
      Swal.fire('Validación', 'Debe aceptar los terminos de protección de datos.', 'error');
    }
  }
  async loadCommercialPurposesPolicy() {
    this.commercialPurposesPolicy = await this.getHtmlPolicy("FINES_COMERCIALES");
  }
  async getHtmlPolicy(key: string) {
    let request = await this.masterService.getHtmlPolicy(key).toPromise();
    if (request.valid) return request.data;
  }
  openCommercialPurposesDialog() {
    const dialog = this.matDialog.open(CommercialPurposeClauseComponent, { data: this.commercialPurposesPolicy });
    dialog.afterClosed().subscribe(response => {

      this.chkAcceptCommerce.checked = response.toString() == 'true' ? true : false;
    })
  }
  
  onChangeConditionAccepted(event: any) {

    this.tiendaVirtualClauseAccepted.enviarMensaje(this.conditionAccepted);

  }
}
